/**
 * App-side rules aligned with copy shown to users (Supabase may enforce only length by default).
 */
export function passwordMeetsPolicy(password) {
  if (typeof password !== 'string' || password.length < 6) return false;
  if (!/[a-z]/.test(password)) return false;
  if (!/[A-Z]/.test(password)) return false;
  if (!/\d/.test(password)) return false;
  if (!/[^A-Za-z0-9]/.test(password)) return false;
  return true;
}

/** Map GoTrue / Supabase errors that indicate password validation failure. */
export function isSupabasePasswordPolicyError(err) {
  if (!err || typeof err !== 'object') return false;
  const code = err.code;
  if (code === 'weak_password') return true;
  const msg = String(err.message || '').toLowerCase();
  if (!msg) return false;
  return (
    msg.includes('weak password')
    || msg.includes('password is known')
    || msg.includes('strength')
    || msg.includes('least 6')
    || msg.includes('at least 6')
    || msg.includes('6 characters')
    || msg.includes('password should')
    || msg.includes('pwned')
    || msg.includes('requirements')
  );
}
